module.exports = __webpack_public_path__ + "media/images/webpage/shared/sale/link-640x640-68501245e6285073935476dc7e2c93f6.webp";